import { IParams } from 'interface/accounts';
import { getStore } from 'redux/store';
import { ACCOUNTS_TOKEN, COOKIE_DOMAIN, IS_PROD, ACCOUNTS_AMBIENT, NUTROR_LOGO } from 'settings';
import { appPostMessage, getCdnUrl, getCourseHash, hjTagging, removeURLParameter } from 'utils';
import * as loginService from 'services/login';
import { sendElastic } from 'actionCreators/judasLog';
import { receiveLogin } from 'actionCreators/auth';
import { pushMessage } from 'actionCreators/messages';
import { cleanUserProfile } from 'actionCreators/user';

class Accounts {
  private readonly accounts = (window as any).Eduzz?.Accounts;
  private readonly createMode = String(window.location).includes('cadastro');
  private readonly urlParams = new URLSearchParams(window.location.search);
  private readonly accountsEnv = !IS_PROD ? ACCOUNTS_AMBIENT : '';

  public login() {
    const state = getStore().getState();
    if (state.auth.isAuthenticated) {
      return;
    }
    this.accounts?.login(ACCOUNTS_TOKEN, this.getAccountsLoginParams()).subscribe((token: any) => {
      if (token) {
        this.requestLogin(token);
      }
      const params = removeURLParameter(window.location.search, 'accounts_token');
      window.history.pushState(null, null, `${window.location.pathname}${params}`);
    });
  }

  public logout = (redirectTo: string = '') => {
    const dispatch = getStore().dispatch;
    sendElastic('logout', 'Saiu do sistema');
    dispatch(cleanUserProfile());
    localStorage.removeItem('newAuthToken');
    localStorage.removeItem('refreshToken');
    window.document.cookie = `userSession=; domain=${COOKIE_DOMAIN}; path=/`;
    appPostMessage('auth', { token: null, refreshToken: null });
    (window as any).Eduzz.Accounts.logout({
      redirectTo: window.location.origin + redirectTo,
      env: !IS_PROD ? 'qa' : '',
    });
  };

  private requestLogin = (token: string) => {
    const courseHash = getCourseHash();
    const dispatch = getStore().dispatch;
    loginService
      .login(token, courseHash)
      .then((response) => {
        dispatch(receiveLogin(response.data.data));
        sendElastic('login', 'Entrou no sistema');
      })
      .catch((e) => {
        hjTagging('ERRO-LOGIN');
        this.logout();
        const details = e.response && e.response.data && e.response.data.details;
        dispatch(pushMessage(details || 'Erro ao enviar solicitação!', 'error'));
      });
  };

  private getTemplate = () => {
    const customization = getStore().getState().customization.customizationData;
    const baseTemplate = getStore().getState().template.base;
    if (Object.entries(customization).length > 0) {
      return customization;
    }
    if (baseTemplate?.login_page?.logo_login || baseTemplate?.login_page?.login_background_image) {
      return baseTemplate.login_page;
    }
    return null;
  };

  private getAccountsLoginParams() {
    const template = this.getTemplate();
    const params: IParams = {
      logo: NUTROR_LOGO,
      bg: getCdnUrl('/assets/img/background_default.jpg'),
      create: String(this.createMode),
      register: 'false',
      env: this.accountsEnv,
      email: this.urlParams.get('email'),
    };
    if (!template) {
      return params;
    }
    return {
      ...params,
      logo: template.logo_login ? getCdnUrl(template.logo_login) : NUTROR_LOGO,
      bg: getCdnUrl(
        !!template.login_background_image ? template.login_background_image : '/assets/img/background_default.jpg'
      ),
    };
  }
}

export default new Accounts();
